import { CtaType } from "../../../types/Cta";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { CTAS } from "../../../utils/constants";

export const getCtas = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams({
        PageNumber: data?.PageNumber?.toString() || '1',
        PageSize: data?.PageSize?.toString() || '100',
        ...(data?.Role ? { Role: data.Role } : {}),
        ...(data?.IdUser ? { IdUser: data.IdUser } : {}),
        ...(data?.IdStudent ? { IdStudent: data.IdStudent } : {}),
    });
    const url = `${CTAS}?${queryParams.toString()}`;
    return await get<PagedResultsType<CtaType>>(url)
};